import type { DeliveryStatus } from "@types_def/models/delivery.types";

import type { PublishDeliverySchemaType } from "@/schemas/DeliveryForm/publish-delivery";

import {
  type DeliveryClientPriceSource,
  type DeliveryDriverPriceSource,
  getClientPrice,
  roundCurrency,
} from "./delivery-pricing";

type DeliveryPublishPatchInput = {
  carAvailabilityDate?: PublishDeliverySchemaType["carAvailabilityDate"];
  carDeliveryDeadline?: PublishDeliverySchemaType["carDeliveryDeadline"];
  carPickUpDate?: PublishDeliverySchemaType["carPickUpDate"];
  clientFinalPrice?: number | null;
  maxPrice?: number | null;
  minPrice?: number | null;
  status: DeliveryStatus;
  wantedPrice?: number | null;
};

export function getDeliveryPublishPatch(
  data: DeliveryClientPriceSource & DeliveryDriverPriceSource,
  input: DeliveryPublishPatchInput
) {
  return {
    status: input.status,
    wantedPrice: roundCurrency(input.wantedPrice ?? data.wantedPrice ?? 0),
    minPrice: roundCurrency(input.minPrice ?? data.minPrice ?? 0),
    maxPrice: roundCurrency(input.maxPrice ?? data.maxPrice ?? 0),
    clientFinalPrice: roundCurrency(
      input.clientFinalPrice ?? data.clientFinalPrice ?? data.clientInitialPrice ?? 0
    ),
    carAvailabilityDate: input.carAvailabilityDate,
    carPickUpDate: input.carPickUpDate,
    carDeliveryDeadline: input.carDeliveryDeadline,
  };
}

export function buildPublishPricing(
  value: PublishDeliverySchemaType,
  delivery: DeliveryDriverPriceSource
) {
  return {
    clientFinalPrice: roundCurrency(value.clientFinalPrice ?? getClientPrice(delivery)),
    wantedPrice: roundCurrency(value.wantedPrice ?? delivery.wantedPrice ?? 0),
    minPrice: roundCurrency(value.minPrice ?? delivery.minPrice ?? 0),
    maxPrice: roundCurrency(value.maxPrice ?? delivery.maxPrice ?? 0),
    carAvailabilityDate: value.carAvailabilityDate,
    carPickUpDate: value.carPickUpDate,
    carDeliveryDeadline: value.carDeliveryDeadline,
  };
}

export type PublishPricing = ReturnType<typeof buildPublishPricing>;
